import React from 'react'
import { withIcon } from '../../withIcon'

function CommentSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M17.157 16.8728L15.022 14.9998H6.4996C6.43391 14.9998 6.36888 14.9877 6.30821 14.9643C6.24753 14.9409 6.19241 14.9065 6.14601 14.8633C6.0996 14.82 6.06281 14.7686 6.03776 14.7121C6.01271 14.6556 5.99988 14.595 6 14.5339V7.46586C6 7.34246 6.05261 7.2241 6.14628 7.13676C6.23995 7.04941 6.36701 7.00023 6.4996 7H17.4994C17.6322 7 17.7595 7.04908 17.8534 7.13645C17.9472 7.22381 18 7.34231 18 7.46586V16.5341C18.0002 16.625 17.9717 16.714 17.9181 16.7901C17.8645 16.8661 17.7881 16.9259 17.6984 16.9619C17.6087 16.998 17.5096 17.0087 17.4134 16.9929C17.3171 16.977 17.228 16.9353 17.157 16.8728Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CommentSolidIcon)
